var map = {
	"./biot.webp": 101,
	"./cover.webp": 102,
	"./do.webp": 103,
	"./doHack.webp": 104,
	"./grandTech.webp": 105,
	"./hoc.webp": 106,
	"./summerSchool.webp": 107,
	"./training.webp": 108,
	"./xtreem.webp": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;